export default __webpack_public_path__ + "static/media/shallow-grave.745da010.png";